import CreateDepartmentChannelButton from "./CreateDepartmentChannel";
export { CreateDepartmentChannelModal } from "./CreateDepartmentChannel";
export default CreateDepartmentChannelButton;
